import { createApp } from 'vue';

export function mountIfExists(selector, component, props = {}) {
  const el = document.querySelector(selector);
  if (el) {
    createApp(component, props).mount(el);
    return true;
  }
  return false;
}


